<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="worktimes.data"
      style="width: 100%"
      row-key="id"
      border
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="80"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="worktimeReport"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
        </template>
      </el-table-column>
      <template slot="append">

      </template>
    </el-table>

    <div class="el-card-footer">
      <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="worktimes.per_page"
          layout="total, prev, pager, next"
          :total="worktimes.total"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        itemLoading: 0,
        currentSort: {
          prop: 'enter',
          order: 'ascending',
        },
      };
    },
    computed: {
      worktimes() {
        return this.$store.getters['worktimeReport/worktimes'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['worktimeReport/tableConfig']));
      },
      loading() {
        return this.$store.getters['worktimeReport/loading'];
      },
      currentPage() {
        return this.$store.getters['worktimeReport/currentPage'];
      },
    },

    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('worktimeReport/setFilterString', '');
      this.$store.commit('worktimeReport/setSorting', this.currentSort);
      await this.$store.dispatch('worktimeReport/fetchAll');
    },
    methods: {
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('worktimeReport/setSorting', { prop, order });
          this.$store.dispatch('worktimeReport/fetchAll');
        }
      },

      handleCurrentChange(val) {
        this.$store.commit('worktimeReport/setCurrentPage', val)
        this.$store.dispatch('worktimeReport/fetchAll');
      },
    },
  };
</script>
<style lang="scss">
  .outstanding-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
